import {
  inject,
  NgModule,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { SharedModule } from './shared/shared.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { isPlatformBrowser } from '@angular/common';
import { TenantService } from './core/services/tenant.service';
import { AUTH_CONFIG, LOGIN_SUCCESS_REDIRECT } from '@adminprodigydesign/axis';
import { environment } from '../environments/environment';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './core/services/auth.service';

export function initTenantConfig() {
  const tenantService = inject(TenantService);
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    return Promise.resolve();
  }

  // IMPORTANT: never let this reject and blank the app
  return tenantService.loadTenantConfig().catch((err) => {
    console.error('[Client-side] Tenant config failed:', err);
    return Promise.resolve();
  });
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    FontAwesomeModule,
    BrowserAnimationsModule,
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    provideAppInitializer(initTenantConfig),
    { provide: LOGIN_SUCCESS_REDIRECT, useValue: '/live-orders' },
    {
      provide: AUTH_CONFIG,
      useValue: {
        apiUrl: environment.apiBaseUrl,
      },
    },
    { provide: 'AuthService', useExisting: AuthService }, // Provide AuthService to Axis
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
